export const CHARGE_OPTIONS = [
    { value: "Charges for Certification", label: "Charges for Certification" },
    { value: "Clearing Forwarding Charges", label: "Clearing Forwarding Charges" },
    { value: "Delivery Order Charges", label: "Delivery Order Charges" },
    { value: "Export Preparation Charges", label: "Export Preparation Charges" },
    { value: "Extra Machining Charges", label: "Extra Machining Charges" },
    { value: "Handling Charges", label: "Handling Charges" },
    { value: "IGC Charges", label: "IGC Charges" },
    { value: "Import Preparation Charges", label: "Import Preparation Charges" },
    { value: "Inspection Charges", label: "Inspection Charges" },
    { value: "Insurance Charges", label: "Insurance Charges" },
    { value: "Labour Charges", label: "Labour Charges" },
    { value: "Late Delivery Charges", label: "Late Delivery Charges" },
    { value: "Packing & Forwarding Charges", label: "Packing & Forwarding Charges" },
    { value: "Pattern Charges", label: "Pattern Charges" },
    { value: "Technical Service Charges", label: "Technical Service Charges" },
    { value: "Testing & Inspection Charges", label: "Testing & Inspection Charges" },
    { value: "Transportation Charges", label: "Transportation Charges" },
];

export const UNIT_OPTIONS = [
    { value: "", label: "Select UOM" },
    { value: "bot", label: "Bot" },
    { value: "ctn", label: "Ctn" },
    { value: "days", label: "Days" },
    { value: "ft", label: "Ft" },
    { value: "hrs", label: "Hrs" },
    { value: "kg", label: "Kg" },
    { value: "ltr", label: "Ltr" },
    { value: "mtr", label: "Mtr" },
    { value: "nos", label: "Nos" },
    { value: "pil", label: "Pil" },
    { value: "pkt", label: "Pkt" },
    { value: "set", label: "Set" },
    { value: "pcs", label: "Pcs" },
];